














































































































import { Component, Vue } from "vue-property-decorator";
import Header from '@/components/Header.vue';
import ProcessedRecordModel from '@/models/ProcessedRecordModel';
import Api from '@/store/surelockApi';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { getInstance } from "@/auth/authPlugin";
import { PRESERVATION_STATUSES, SURELOCK_SCOPES } from "@/utils/constants";
import CompressedFiles from "@/components/surelock/CompressedFiles.vue";
import ProcessedVideos from "@/components/surelock/ProcessedVideos.vue";
import EditPreservation from "@/components/surelock/EditPreservation.vue";

import _ from 'lodash';
import PreservationModel from "@/models/PreservationModel";

dayjs.extend(utc);
dayjs.extend(timezone);

@Component({
  components: {
    Header,
    ProcessedVideos,
    CompressedFiles,
    EditPreservation,
    FontAwesomeIcon,
  },
})
export default class Preservation extends Vue {
  links = [
    { text: 'Portal', to: '/' },
    { text: 'SureLock', to: '/surelock' },
    { text: 'Preservation', active: true },
  ];

  preservationId = '';
  processedRecords = new Array<ProcessedRecordModel>();
  preservationData = {} as PreservationModel;
  password = '';
  zipCount = 0;
  compressedStatus = '';

  // Password Rendering Variables
  hidePassword = true;
  passwordInputType = 'password';

  // Sent
  sent = false;  

  zipsDataIsReady = false;
  videosDataIsReady = false;
  preservationDataIsReady = false;

  createUser = false;
  retrievalUser = false;

  async mounted(): Promise<void> {
    const authService = getInstance();
    this.retrievalUser = await authService.userHasSurelockScope(
      SURELOCK_SCOPES.RETRIEVE_PRESERVATION
    );
    this.createUser = await authService.userHasSurelockScope(
      SURELOCK_SCOPES.CREATE_PRESERVATION
    );

    this.preservationId = this.$route.params.preservationId;
    await this.loadPreservationData();
  }

  async loadPreservationData(): Promise<void> {
    try {
      const data = await Api.getPreservationById(this.preservationId);
      this.preservationData = data.preservation;

      this.preservationDataIsReady = true;
    } catch (err) {
      const message = _.get(err, 'response.data.message') || 'Error loading Preservation';
      this.$toasted.error(message, { duration: 3000 });
      return;
    }
  }

  shouldRenderData(): boolean {
    return this.preservationDataIsReady;
  }

  showUpdateModal(): void {
    const editModal = this.$refs.edit as EditPreservation;
    editModal.showModal(this.preservationData, async () => {
      await this.loadPreservationData();
    });
  }

  setPassword(password: string): void {
    this.password = password;
  }

  setZippedCount(count: number): void {
    this.zipCount = count;
  }

  setCompressedStatus(status: string): void {
    this.compressedStatus = status;
  }

  // Password Container Functions
  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
    this.passwordInputType = this.hidePassword? 'password' : 'text';
  }

  copyToClipboard(): void {
    try {
      const input = document.createElement('input');
      document.body.appendChild(input);

      input.value = this.password;
      input.focus();
      input.select();

      document.execCommand('copy');
      this.$toasted.success('Copied!', {
          position: 'top-left',
          duration: 3000,
        });

      document.body.removeChild(input);
    } catch (err) {
      this.$toasted.error('Failed to copy password', {
        position: 'top-left',
        duration: 5000,
      });
    }
  }

  displayStatus(): string {
    if (this.preservationData && this.preservationData.status) {
      if (this.preservationData.status === PRESERVATION_STATUSES.SUCCESSFUL && this.preservationData.videosInTimespan === 0) {
        return PRESERVATION_STATUSES.NO_RECORDINGS;
      }

      return this.preservationData.status;
    }

    return '';
  }

  // Zip Button Functions
  canCompress(): boolean {
    const isSuccessful = this.preservationData?.status === PRESERVATION_STATUSES.SUCCESSFUL;

    const videosInTimespan = this.preservationData?.videosInTimespan || 0;
    const hasVideos = videosInTimespan > 0;

    return isSuccessful && hasVideos;
  }

  async confirmCompress(): Promise<void> {
    try {
      const value = await this.$bvModal.msgBoxConfirm('Warning, this is a long process. It will delete any existing zip files. Do you want to continue?', {
        buttonSize: 'sm',
        okTitle: 'Continue',
      });

      if (value) {
        this.compress();
      }

    } catch (err) {
      this.$toasted.error('Error trying to confirm the compression', {
        position: 'top-left',
        duration: 5000,
      });
    }
  }

  async compress(): Promise<void> {
    try {
      await Api.compressPreservation(this.preservationId);
    } catch (err) {
      const response = err.response || null;
      let message: string;
      if (response?.statusText) {
        message = response.statusText;
      }
      else if (response?.status === 409) {
        message = 'Maximum number of compress requests reached this hour';
      } else {
        message = 'Compress request failed';
      }

      this.$toasted.error(message, {
          position: 'top-left',
          duration: 4000,
        });
    }
  }
}

